import {
  FC,
  useRef,
  useState,
  useEffect,
  useMemo,
  CSSProperties,
} from 'react';
// 组件
import { ProNotification, ProSpin } from '../antd';
import BaseDetailPage from './subpage/baseDetailPage';
import SuperForm from '../SuperForm';
// 方法
import classnames from 'classnames';
import useDetailPageContext from './hook/useDetailPageContext';
import DetailPageContext from './context';
import useLineNumber from './hook/useLineNumber';
import useFormItems from './hook/useFormItems';
import { formatInitData, getUploadNames, setDetailPageVisible } from './util';
import { responseSuccess } from '../utils/messageUtils';
// 常量
import { SuperFormItemProps } from '../SuperForm/interface';
import { FormInstance } from 'antd/lib/form';
import { SUCCESS_STATUS_CODE } from '../constants/constant';
import { NamePath } from '../constants/interface';
import { DetailActionType as ActionType, DetailPageAddProps as  AddProps} from './interface';

export type DetailActionType = ActionType | undefined;
export type DetailPageAddProps = AddProps;
const spinStyle: CSSProperties = { display: 'flex', };

/** 详情页 */
const DetailPageAdd: FC<DetailPageAddProps> = props => {
  const {
    formItems,
    size,
    defaultLineNumber,
    defaultLabelCol,
    confirmLoading,
    initformValues,
    formValues,
    actionRef,
    disabledAll,
    header,
    tableId,
    testId = 'detail',
    destroyOnClose,
    wrapperClassName,
    drafts,
    draftsData,
    isFullPage,
    isBackList,
    otherHideClassName,
    headerProps,
    isTableDetail,
    formatData,
    fetchApi,
    beforeSubmit,
    beforeDraftsSubmit,
    onSuccess,
    onFail,
    onSubmit,
    onSuccessed,
    onVisibleChange,
    ...resProps
  } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const { visible, pageType, dispatchDetailPage } = useDetailPageContext();
  const [submitLoading, setSubmitLoading] = useState<boolean>(
    confirmLoading || false,
  );
  const tableRef = useRef<HTMLElement>();
  const detailRef = useRef<HTMLDivElement>(null);
  const detailParentRef = useRef<HTMLElement>(); //yb-layout-page-detail
  const superFormRef = useRef<FormInstance>();
  const historyInitValue = useRef<any>({});
  const uploadNames = useMemo(() => {
    return getUploadNames(formItems);
  }, [formItems]);

  useEffect(() => {
    setDetailPageVisible(tableRef, detailRef, detailParentRef, visible, tableId, isTableDetail, handleHidden);
  }, [visible]);
  const handleHidden = () => {
    if (otherHideClassName) {
      const classEle = document.getElementsByClassName(otherHideClassName);
      for (let val of Object.values(classEle)) {
        (val as HTMLElement).style.display = visible ? 'none' : '';
      }
    }
    onVisibleChange?.(!!visible);
  }
  const { currentFormItems, formItemDispatch } = useFormItems(
    formItems || [],
    disabledAll || pageType === 'detail',
    destroyOnClose && !visible,
    superFormRef,
    historyInitValue,
  );
  const { lineNumber, labelCol } = useLineNumber(
    size,
    defaultLineNumber,
    defaultLabelCol,
  );
  useEffect(() => {
    if (actionRef && actionRef.current) {
      actionRef.current.form = superFormRef.current;
    }
  }, [currentFormItems]);
  const setFieldsValue = (initValues: any) => {
    setTimeout(() => {
      if (superFormRef.current) {
        superFormRef.current.resetFields();
        superFormRef.current.setFieldsValue(initValues);
      }
    }, 50);
  };
  useEffect(() => {
    setSubmitLoading(confirmLoading || false);
  }, [confirmLoading]);
  useEffect(() => {
    if (!formValues) return;
    superFormRef.current && superFormRef.current.setFieldsValue(formValues);
  }, [formValues]);
  const handleOk = async () => {
    const values: any = await validateFields();
    // const errorInfo = superFormRef.current?.getFieldsError();
    // const validateError = validateErrorFields(errorInfo);
    if (values) superFormRef.current?.submit();
    // superFormRef.current && superFormRef.current.submit();  superFormRef.current.submit();
  };
  const validateFields = async () => {
    return superFormRef.current
      ?.validateFields()
      .then((values: any) => {
        return values;
      })
      .catch((errorInfo: any) => {
        if (Array.isArray(errorInfo.errorFields)) {
          const messageNode = (
            <>
              {errorInfo.errorFields.map((v: any) => (
                <div key={v.name[0]}>{v.errors[0]}</div>
              ))}
            </>
          );
          ProNotification.warning({
            message: messageNode,
            className: 'detail-page-require',
          });
        }
      });
    // superFormRef.current && superFormRef.current.submit();
  };
  const handleDrafts = async (values: any) => {
    if (!drafts) return;
    const { isCover, draftsName } = values;
    const detailData = superFormRef.current?.getFieldsValue();
    const fetch = isCover ? drafts.updateFetchApi : drafts.createFetchApi;
    if (fetch) {
      let params = detailData;
      if (beforeDraftsSubmit) {
        const newParams = await beforeDraftsSubmit(isCover, detailData);
        if (!newParams) return;
        params = newParams;
      }
      setSubmitLoading(true);
      const defaultParams = isCover
        ? { draftsId: draftsData?.draftsId, draftsName }
        : { draftsName };
      const res = await fetch({ ...defaultParams, ...params });
      setSubmitLoading(false);
      if (res.code === SUCCESS_STATUS_CODE) {
        dispatchDetailPage('change', { visible: false });
        drafts.onSuccess?.(res.data);
        if (!isCover) drafts.onUpdateCount?.();
        return;
      }
      drafts.onFail?.(res);
      return;
    }
    console.error('fetchApi、updateFetchApi 或 onSubmit 必须定义一个');
  };
  const handleFinish = async (values: any) => {
    // 如果定义了onSubmit方法，则新增步骤由外部实现
    if (onSubmit) {
      onSubmit(values);
      return;
    }
    if (fetchApi) {
      let params = values;
      if (beforeSubmit) {
        const newParams = await beforeSubmit(values);
        if (!newParams) return;
        params = newParams;
      }
      setSubmitLoading(true);
      const res = await fetchApi(params);
      setSubmitLoading(false);
      if (res.code === SUCCESS_STATUS_CODE) {
        responseSuccess('操作成功');
        onSuccess && onSuccess(res);
        if (!isBackList) {
          const data = res.data;
          onSuccessed?.(data);
          handleDetail(formatData ? formatData(data) : data);
        }
        return;
      }
      // responseError(res);
      onFail && onFail(res);
      return;
    }
    console.error('fetchApi 或 onSubmit 必须定义一个');
  };
  const handleDetail = (initValues: any) => {
    superFormRef.current?.resetFields();
    dispatchDetailPage('change', { visible: true, pageType: 'detail' });
    formItemDispatch({ type: 'selectTable', payload: { initValues } });
    setFieldsValue(formatInitData(initValues, uploadNames));
  };
  if (actionRef && typeof actionRef !== 'function') {
    actionRef.current = {
      hide: () => {
        dispatchDetailPage('change', { visible: false });
      },
      show: () => {
        dispatchDetailPage('change', { visible: true });
        return actionRef.current;
      },
      loading: () => {
        setLoading(true);
        return actionRef.current;
      },
      unLoading: () => {
        setLoading(false);
        return actionRef.current;
      },
      add: (initValues?: any) => {
        historyInitValue.current = initValues;
        dispatchDetailPage('change', { visible: true, pageType: 'add' });
        formItemDispatch({
          type: 'selectTable',
          payload: { initValues: initValues || {} },
        });
        setFieldsValue(formatInitData(initValues, uploadNames));
        return actionRef.current;
      },
      edit: (initValues: any) => {
        historyInitValue.current = initValues;
        dispatchDetailPage('change', { visible: true, pageType: 'edit' });
        formItemDispatch({ type: 'selectTable', payload: { initValues } });
        setFieldsValue(formatInitData(initValues, uploadNames));
        return actionRef.current;
      },
      detail: (initValues: any) => {
        historyInitValue.current = initValues;
        handleDetail(initValues);
        return actionRef.current;
      },
      update: (name: NamePath, formItem: SuperFormItemProps) => {
        formItemDispatch({ type: 'updata', payload: { name, formItem } });
        return actionRef.current;
      },
      validateFields: validateFields,
      submit: handleOk,
      getForms: () => superFormRef.current,
      form: superFormRef.current,
    };
  }
  const classes = classnames('tl-detail-wrappper', wrapperClassName);

  return (
    <>
      {visible ? (
        <div ref={detailRef} className={classes}>
          <DetailPageContext.Provider
            value={{ visible, pageType, dispatchDetailPage }}
          >
            <ProSpin
              spinning={loading}
              style={spinStyle}
            >
              <BaseDetailPage
                {...resProps}
                headerProps={headerProps}
                drafts={drafts}
                draftsData={draftsData}
                size={size}
                onOk={handleOk}
                onDrafts={handleDrafts}
                confirmLoading={submitLoading}
                isFullPage={isFullPage}
              >
                {header}
                {currentFormItems && (
                  <SuperForm
                    actionRef={superFormRef}
                    testId={testId}
                    formItems={currentFormItems}
                    formType="detail"
                    defaultLineNumber={lineNumber}
                    defaultLabelCol={labelCol}
                    onFinish={handleFinish}
                    initialValues={initformValues}
                    isFullPage={isFullPage}
                  />
                )}
              </BaseDetailPage>
            </ProSpin>
          </DetailPageContext.Provider>
        </div>
      ) : null}
    </>
  );
};

DetailPageAdd.defaultProps = {
  size: 'full',
  minWidth: 900,
  disabledAll: false,
  formItems: [],
  destroyOnClose: false,
  drafts: false,
  isBackList: true,
  isTableDetail: true,
};

export default DetailPageAdd;
